import { isAfter, isBefore, isValid, subYears } from 'date-fns';
import { useFormik } from 'formik';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import { MdPersonOutline } from 'react-icons/md';
import { AiOutlineCalendar } from 'react-icons/ai';
import CustomDatePickerInput from 'components/newForm/CustomDatePickerInput';
import { connect } from 'react-redux';
import * as Yup from "yup";
import ContainedButton from 'components/layout/form/containedButton';
import CustomInput from "components/newForm/CustomInput";
import OutlinedButton from 'components/layout/form/outlinedButton';
import { Link } from 'react-router-dom';
import Modal from './Modal';
import { registerValuesMembership } from 'store/actions/membership-actions';
import theme from 'styles/theme';
import { removeSpecialCharacters } from 'utils/functions';
import { fullNameWithNumberRegex } from 'utils/regex';
import { validateCNPJ } from "utils/functions";

import {
  ButtonsContainer,
  Container,
  Field,
  FormContainer,
  Header,
  InputsContainer,
  MessagerAwait,
} from './styles';

const PersonalData = ({ dispatch, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [birthdate, setBirthdate] = useState(props.birthdate ? new Date(props.birthdate) : null);
  const [date, setDate] = useState("");

  useEffect(() => {
    if (birthdate && props.birthdate) {
      const dateProps = new Date(props.birthdate);
      if (
        dateProps.getDay() !== birthdate.getDay() &&
        dateProps.getMonth() !== birthdate.getMonth() &&
        dateProps.getFullYear() !== birthdate.getFullYear()
      ) {
        setBirthdate(props.birthdate ? new Date(props.birthdate) : null);
      }
    }
  }, [props.birthdate]);

  const handleCloseModal = () => {
    setLoading(false);
    setShowModal(false);
  }

  useEffect(() => {
    if (props.name || props.nameCompletedSerasa) {
      formik.setFieldValue("name", props.name || props.nameCompletedSerasa);
    }
    if (props.nameCompletedSerasa) {
      formik.setFieldValue("nameCompletedSerasa", props.nameCompletedSerasa);
    }

    if (birthdate) {
      formik.setFieldValue("birthdate", BuildFormmatedDate(birthdate));
    }
  }, [props.name, props.nameCompletedSerasa, birthdate]);

  const nameDisabled = useMemo(() => {
    if (validateCNPJ(props.document)) {
      return false
    }
    return ((props.nameCompletedSerasa) ? true : false) || loading
  }, [props.document, props.nameCompletedSerasa, loading])

  const validationSchema = () => Yup.object().shape({
    name: Yup.string().required("É necessário digitar seu nome completo"),
    birthdate: Yup.string().required("É necessário entrar com a data de nascimento")
  });

  const validDateReported = (dateValue) => {
    const format = `${dateValue.split('/').reverse().join('-')} 00:00:00`
    return isValid(new Date(format));
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      nameCompletedSerasa: "",
      birthdate: "",
    },
    validationSchema,
    onSubmit: async (values, ctx) => {
      const name = removeSpecialCharacters(values?.name);
      const nameTestRegex = new RegExp(fullNameWithNumberRegex);

      const isValidDate = validDateReported(values?.birthdate);

      if(!isValidDate) {
        return ctx.setFieldError("birthdate", "Data inválida");
       }

      if (nameTestRegex.test(name)) {
        const result = buildFormatObject({
          ...values,
          name,
        });

        await dispatch(registerValuesMembership(result));
        setShowModal(true);
      } else {
        ctx.setFieldError(
          "name",
          "É necessário digitar seu nome completo sem caracteres especiais"
        );
        return false;
      }
    },
  });

  const buildFormatObject = useCallback(({ name, birthdate }) => {
    if (birthdate.length) {
      const dateArray = birthdate.split('/');
      dateArray[0] = dateArray[0].length === 1 ? `0${dateArray[0]}` : dateArray[0];
      dateArray[1] = dateArray[1].length === 1 ? `0${dateArray[1]}` : dateArray[1];
      birthdate = `${dateArray[2]}-${dateArray[1]}-${dateArray[0]}`;
    }

    const objectFormmated = {
      name,
      birthdate,
    };
    return objectFormmated;
  }, [props]);

  const HandleChangeBirhdate = useCallback(date => {
    setBirthdate(date);
  }, [setBirthdate]);

  const BuildFormmatedDate = useCallback((val) => {
    if (val) {
      const date = new Date(val);
      const day = date.getDate().toString().length > 1 ? date.getDate() : "0" + date.getDate();
      const month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1) : "0" + (date.getMonth() + 1);
      return day + "/" + month + "/" + date.getFullYear();
    }
    return null;
  }, []);

  useEffect(() => {
    formik.setFieldValue("birthdate", date);
  }, [date]);

  const errorDate = useMemo(() => {
    const minDate = subYears(new Date(), 120);
    const maxDate = subYears(new Date(), 18);

    const dateSplit = date.split("/");
    const dateFormatted = new Date(
      Number(dateSplit[2]),
      Number(dateSplit[1]) - 1,
      Number(dateSplit[0])
    );

    const isBeforeDate = isBefore(dateFormatted, minDate);
    const isAfterDate = isAfter(dateFormatted, maxDate);

    if (isBeforeDate) {
      return "Data inválida! Verifique a data informada para continuar o cadastro!";
    }

    if (isAfterDate) {
      return "Verifique a data informada! Cadastro não permitido para menores de 18 anos.";
    }
    return "";
  }, [date]);

  const minDate = useMemo(() => {
    return subYears(new Date(), 120)
 }, [subYears]);

 const maxDate = useMemo(() => {
   return subYears(new Date(), 18)
 }, [subYears]);

  return (
    <Container>
      <Header>
        <h1>Dados pessoais</h1>
        <h2>Agora informe seus dados pessoais</h2>
      </Header>

      <FormContainer onSubmit={formik.handleSubmit}>
        <InputsContainer>
          <Field>
          <CustomInput
            disabled={nameDisabled}
            icon={() => <MdPersonOutline size={24} />}
            id="name"
            name="name"
            inputType="text"
            labelText="Nome completo *"
            msgError={formik.errors.name}
            onBlur={formik.handleBlur}
            value={formik.values.name}
            onChange={formik.handleChange}
            errorCondition={
              !!formik.errors.name && !!formik.touched.name
            }
          />
          </Field>
          <Field>
            <CustomDatePickerInput
              setDate={setDate}
              disabled={loading}
              icon={AiOutlineCalendar}
              id="birthdate"
              name="birthdate"
              inputType="text"
              labelText="Data de nascimento *"
              msgError={formik.errors.birthdate || errorDate}
              onBlur={formik.handleBlur}
              value={formik.values.birthdate}
              onChange={formik.handleChange}
              errorCondition={
              (!!formik.errors.birthdate && !!formik.touched.birthdate) ||
              !!errorDate
              }
              mask="99/99/9999"
              minDate={minDate}
              maxDate={maxDate}
            />
          </Field>
        </InputsContainer>

        <ButtonsContainer>
          <ContainedButton
            block
            type="submit"
            continue
            disabled={loading || !formik.values.name || !formik.values.birthdate || formik.errors.birthdate || formik.errors.name || !!errorDate}
            id="Avançar"
            width="100%"
            TrailingIcon={() => <IoMdArrowForward size={20} />}
          >
            Continuar
          </ContainedButton>
          {loading && <MessagerAwait>*O cadastro pode levar algum tempo por favor aguarde.</MessagerAwait>}
          <Link to="/primeiro-acesso-mi">
            <OutlinedButton
              width="100%"
              LeadingIcon={() => <IoMdArrowBack size={20} />}
              color={theme.colors.purple}
            >
              Voltar
            </OutlinedButton>
          </Link>
        </ButtonsContainer>
      </FormContainer>
      <Modal show={showModal} handleCloseModal={handleCloseModal} />
    </Container>
  );
}

const mapStateToProps = state => ({
  name: state.membershipReducer.name,
  document: state.membershipReducer.document,
  phoneDdd: state.membershipReducer.phoneDdd,
  phoneNumber: state.membershipReducer.phoneNumber,
  email: state.membershipReducer.email,
  emailToken: state.membershipReducer.emailToken,
  birthdate: state.membershipReducer.birthdate,
  unit: state.membershipReducer.unit,
  address: state.membershipReducer.address,
  nameCompletedSerasa: state.membershipReducer.nameCompletedSerasa,
  blockIdSf: state.membershipReducer.blockIdSf,
  condominiumIdSf: state.membershipReducer.condominiumIdSf,
  organizationId: state.membershipReducer.organizationId
});

export default connect(mapStateToProps)(PersonalData);
